import Typo from "typo-js";

// Hunspell en_US dictionary served from /public/dict — loaded once, lazily.
let dictPromise = null;
export function loadDictionary() {
  if (!dictPromise) {
    dictPromise = Promise.all([
      fetch("/dict/en_US.aff").then((r) => r.text()),
      fetch("/dict/en_US.dic").then((r) => r.text()),
    ]).then(([aff, dic]) => new Typo("en_US", aff, dic));
  }
  return dictPromise;
}

// Returns [{word, suggestions}] for misspelled words in the text.
// Skips short tokens, ALL-CAPS acronyms and words whose lowercase form
// passes (proper nouns at sentence starts).
export async function checkSpelling(text) {
  const dict = await loadDictionary();
  const words = [...new Set(text.match(/[A-Za-z][A-Za-z']*/g) || [])];
  const issues = [];
  for (const w of words) {
    if (w.length < 3) continue;
    if (/^[A-Z0-9']+$/.test(w)) continue;
    if (dict.check(w)) continue;
    if (dict.check(w.toLowerCase())) continue;
    issues.push({ word: w, suggestions: (dict.suggest(w, 3) || []).slice(0, 3) });
  }
  return issues;
}
